import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppRouteURL, AppRouteURLwithChilds } from '@Constants/app-route-url.constant';
import { Card } from 'primereact/card';
import SvgIcon from "@Components/icons/SvgIcon";
import VideoTutorialsSlider from "./VideoTutorialsSlider";

import './VideoTutorials.scss'
import { getHomeCmsList } from '../../services/Home.service';

interface VideoTutorialsProps {
    filters?: {
        boardId?: number;
        classId?: number;
        subjectId?: number[];
        page?: number;
        limit?: number;
    };
    playInPlace?: boolean;
}

export const VideoTutorials: React.FC<VideoTutorialsProps & { usePublicApi?: boolean }> = ({ filters, playInPlace, usePublicApi = false }) => {
    const [hasVideos, setHasVideos] = useState<boolean>(true); // Default to true to avoid layout shift before fetch
    const [cmsData, setCmsData] = useState<any[]>([]);
    const handleDataLoaded = (videos: any[]) => {
        setHasVideos(videos && videos.length > 0);
    };

    if (!hasVideos) {
        return null;
    }

    const getHomeCmsListDetails = async () => {
        try {
            const response = await getHomeCmsList();
            if (response.ResponseType === "SUCCESS" && response.data) {
                setCmsData(response.data);

            }
        } catch (error) {
            console.error("Error fetching CMS data for Video Tutorials:", error);
        }
    }
    useEffect(() => {
        getHomeCmsListDetails();
    }, []);
    return (
        <section className="videotutorials-container">
            <div className="ia-container my-2 lg:my-6">
                <div className="main-header-card tw-text-center">
                    <span dangerouslySetInnerHTML={{ __html: cmsData.find(item => item.KeyName === "video-title")?.Description || "<h2 >Grasp Chapters in <span>Minutes with Video Lessons</span></h2><p>Watch quick videos that explain the exact concepts you need across PCM, Biology & more. </p>" }}></span>

                </div>
                <div className='videotutorials-slider'>
                    <VideoTutorialsSlider
                        filters={filters}
                        playInPlace={playInPlace}
                        onDataLoaded={handleDataLoaded}
                        {...{ usePublicApi } as any}
                    />
                </div>

            </div>
        </section>
    )
}